import React, { useEffect, Suspense, lazy } from 'react';
import { BookPromo } from './components/BookPromo';
const SalesPopup = lazy(() => {
  return new Promise(resolve => {
    // Add a small timeout to prevent immediate network requests on load
    setTimeout(() => {
      import('./components/SalesPopup').then(module => {
        resolve({
          default: module.SalesPopup
        });
      }).catch(error => {
        console.error('Failed to load SalesPopup:', error);
        resolve({
          default: () => null
        }); // Fallback empty component
      });
    }, 100);
  });
});
export function App() {
  useEffect(() => {
    // Debug log to check component rendering
    console.log('App component mounted');
    // Add a check to see if components are visible
    setTimeout(() => {
      const heroSection = document.querySelector('.hero-section');
      const storySection = document.querySelector('.story-section');
      const quotesSection = document.querySelector('.quotes-section');
      const bookDetailsSection = document.querySelector('.book-details-section');
      const specialOffer = document.querySelector('#offer');
      console.log('Hero section visible:', !!heroSection);
      console.log('Story section visible:', !!storySection);
      console.log('Quotes section visible:', !!quotesSection);
      console.log('Book details section visible:', !!bookDetailsSection);
      console.log('Special offer visible:', !!specialOffer);
    }, 500);
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <BookPromo data-id="element-1" />
      <Suspense fallback={null} data-id="element-2">
        <SalesPopup data-id="element-3" />
      </Suspense>
    </div>;
}